import { ConstructionToPermanentRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateConstructionToPermanent = makeValidator({ FieldParser: ConstructionToPermanentRow });
